import CryptoJS from 'crypto-js';

const secretKey = process.env.REACT_APP_USER_ENC_DEC_KEY;

export const getDecryptedData = () => {
  const encryptedData = sessionStorage.getItem("LoginUserDetails");
  if (encryptedData) {
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
  }
  return null;
};

export const getDecryptedUserType = () => {
  const encryptedUserType = sessionStorage.getItem("LoginUserType");
  if (encryptedUserType) {
    const bytes = CryptoJS.AES.decrypt(encryptedUserType, secretKey);
    const decryptedType = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedType;
  }
  return null;
};

export const getDecryptedAccessToken = () => {
  const encryptedAccessToken = sessionStorage.getItem("LoginUserAccessToken");
  if (encryptedAccessToken) {
    const bytes = CryptoJS.AES.decrypt(encryptedAccessToken, secretKey);
    const decryptedToken = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedToken;
  }
  return null;
};

export const getDecryptedRefreshToken = () => {
  const encryptedRefresToken = sessionStorage.getItem("LoginUserRefreshToken");
  if (encryptedRefresToken) {
    const bytes = CryptoJS.AES.decrypt(encryptedRefresToken, secretKey);
    const decryptedRefreshToken = bytes.toString(CryptoJS.enc.Utf8);
    return decryptedRefreshToken;
  }
  return null;
};


export const getPatientListPatientTabsData = () => {
  const encryptedData = sessionStorage.getItem("PatientListPatientTabsData");
  if (encryptedData) {
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
  }
  return null;
};


export const getDecryptedDataFromSessionStorage = (key) => {
  const encryptedData = sessionStorage.getItem(key);
  if (encryptedData) {
    const bytes = CryptoJS.AES.decrypt(encryptedData, secretKey);
    const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedData);
  }
  return null;
};
